import {
  hasAccessToAdminAccountsTab,
  settingsSelectors,
  State,
  TabDisplayInterface,
  UserType,
} from '@wam/shared';
import { Injectable, inject } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { authenticationSelectors } from '@wam/authentication';

@Injectable({
  providedIn: 'root',
})
export class AccountsTabDisplayService implements TabDisplayInterface {
  private store = inject<Store<State>>(Store);

  isFirst(): Observable<boolean> {
    return of(false);
  }

  shouldShow(): Observable<boolean> {
    return combineLatest([
      this.store.pipe(select(settingsSelectors.getUserType)),
      this.store.pipe(select(authenticationSelectors.getUserRoles)),
    ]).pipe(
      map(
        ([userType, userRoles]) =>
          userType === UserType.ADMIN && hasAccessToAdminAccountsTab(userRoles),
      ),
    );
  }
}
